type ToastHandler = {
  showSuccess: (message: string) => void;
  showError: (message: string) => void;
};

let globalToastHandler: ToastHandler | null = null;

export function setGlobalToastHandler(handler: ToastHandler | null) {
  globalToastHandler = handler;
}

export function showGlobalError(message: string) {
  if (globalToastHandler) {
    globalToastHandler.showError(message);
  } else {
    // Fallback to console if provider not mounted yet
    console.error(message);
  }
}

export function showGlobalSuccess(message: string) {
  if (globalToastHandler) {
    globalToastHandler.showSuccess(message);
  } else {
    // Fallback to console if provider not mounted yet
    console.log(message);
  }
}
